// extracted by mini-css-extract-plugin
module.exports = {"DealMain":"DealMain_DealMain__w6Ibo","Show":"DealMain_Show__fs8Od","Hide":"DealMain_Hide__jUZGy","Card":"DealMain_Card__JlUTy"};